"use strict";
// Settings -> Email. Adding a proven email address to the account you are
// already signed in as, so guest claim has an address to match on.
//
// Every style here is lifted from the Profile panel rather than invented:
// the 20px/24px padding, the 520px measure, the back button, the 13px/700
// label, the 50px input with 13px radius on --bg2, the accent-gradient
// submit at 50px, and the same error and feedback treatment. A field on
// this screen and a field on Profile are the same object.
(function () {
    var CODE_LENGTH = 6;
    function t(hubEl, key, fallback) {
        var value = hubEl.dataset[key];
        return value && value.length > 0 ? value : fallback;
    }
    var BACK_ARROW = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></svg>';
    var LABEL_STYLE = "display:block;font-size:13px;font-weight:700;color:var(--dim);margin-bottom:8px";
    var INPUT_STYLE = "width:100%;height:50px;padding:0 16px;border-radius:var(--radius-button);border:1px solid var(--border);background:var(--bg2);color:var(--text);font-size:15px;font-family:var(--body);transition:border-color .2s,box-shadow .2s;outline:none";
    var SUBMIT_STYLE = "height:50px;border-radius:var(--radius-button);border:none;background:linear-gradient(135deg,var(--accent),var(--accent2));color:#160d05;font-family:var(--display);font-weight:800;font-size:14px;cursor:pointer;box-shadow:0 8px 22px -8px var(--glow);transition:transform .2s";
    function shell(hubEl, inner) {
        return ('<div style="max-width:520px">' +
            '<button type="button" data-flix-hub-nav="settings" style="display:inline-flex;align-items:center;gap:8px;background:none;border:none;color:var(--dim);font-size:13px;font-weight:600;cursor:pointer;padding:0;margin-bottom:20px" style-hover="color:var(--text)">' +
            '<span aria-hidden="true" data-flix-hub-back-arrow style="display:flex">' +
            BACK_ARROW +
            "</span>" +
            window.FlixHubFormat.escapeHtml(t(hubEl, "i18nNavSettings", "Settings")) +
            "</button>" +
            '<div data-flix-email-feedback></div>' +
            inner +
            "</div>");
    }
    /** The address already on the account: shown as a settled fact, not a form. */
    function verifiedHtml(hubEl, email) {
        return ('<div data-flix-email-verified style="display:flex;align-items:center;gap:12px;min-height:56px;padding:0 16px;border-radius:var(--radius-md);background:var(--surface);border:1px solid var(--border)">' +
            '<span style="flex:1;font-size:14px;font-weight:600;color:var(--text);word-break:break-all">' +
            window.FlixHubFormat.escapeHtml(email) +
            "</span>" +
            '<span style="flex:none;font-size:10px;font-weight:700;letter-spacing:.3px;padding:3px 8px;border-radius:var(--radius-lg);background:var(--surface2);border:1px solid var(--border);color:var(--success)">' +
            window.FlixHubFormat.escapeHtml(t(hubEl, "i18nEmailVerified", "Verified")) +
            "</span>" +
            "</div>");
    }
    function entryHtml(hubEl) {
        return ('<form data-flix-email-form novalidate style="display:flex;flex-direction:column;gap:16px">' +
            "<div>" +
            '<label for="flix-email-address" style="' +
            LABEL_STYLE +
            '">' +
            window.FlixHubFormat.escapeHtml(t(hubEl, "i18nEmailLabel", "Email")) +
            "</label>" +
            '<input id="flix-email-address" name="email" type="email" inputmode="email" autocomplete="email" autocapitalize="off" spellcheck="false" style="' +
            INPUT_STYLE +
            '" style-focus="border-color:var(--accent);box-shadow:0 0 0 4px var(--glow)">' +
            '<div data-flix-email-error hidden style="margin-top:8px;font-size:13px;color:var(--error)"></div>' +
            "</div>" +
            '<button type="submit" data-flix-email-send style="' +
            SUBMIT_STYLE +
            '" style-hover="transform:translateY(-2px)">' +
            window.FlixHubFormat.escapeHtml(t(hubEl, "i18nEmailSend", "Send code")) +
            "</button>" +
            "</form>");
    }
    function codeHtml(hubEl, email) {
        return ('<p style="font-size:14px;color:var(--dim);margin:0 0 16px;word-break:break-all">' +
            window.FlixHubFormat.escapeHtml(t(hubEl, "i18nEmailCodeSentTo", "We sent a code to")) +
            " " +
            window.FlixHubFormat.escapeHtml(email) +
            "</p>" +
            '<form data-flix-email-code-form novalidate style="display:flex;flex-direction:column;gap:16px">' +
            "<div>" +
            '<label for="flix-email-code" style="' +
            LABEL_STYLE +
            '">' +
            window.FlixHubFormat.escapeHtml(t(hubEl, "i18nEmailCodeLabel", "Code")) +
            "</label>" +
            '<input id="flix-email-code" name="code" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="' +
            CODE_LENGTH +
            '" style="' +
            INPUT_STYLE +
            ';letter-spacing:.5em;text-align:center;font-family:var(--display);font-size:18px" style-focus="border-color:var(--accent);box-shadow:0 0 0 4px var(--glow)">' +
            '<div data-flix-email-error hidden style="margin-top:8px;font-size:13px;color:var(--error)"></div>' +
            "</div>" +
            '<button type="submit" data-flix-email-confirm style="' +
            SUBMIT_STYLE +
            '" style-hover="transform:translateY(-2px)">' +
            window.FlixHubFormat.escapeHtml(t(hubEl, "i18nEmailConfirm", "Confirm")) +
            "</button>" +
            "</form>");
    }
    function showError(root, message) {
        var box = root.querySelector("[data-flix-email-error]");
        if (!box)
            return;
        box.textContent = message;
        box.hidden = false;
    }
    function clearError(root) {
        var box = root.querySelector("[data-flix-email-error]");
        if (box)
            box.hidden = true;
    }
    function busy(button, isBusy) {
        if (!button)
            return;
        button.disabled = isBusy;
        button.style.opacity = isBusy ? "0.6" : "";
    }
    function render(hubEl, contentEl, profile) {
        var existing = "";
        var methods = (profile && profile.authMethods) || [];
        for (var i = 0; i < methods.length; i += 1) {
            var method = methods[i];
            // An active email method only — a revoked one is history, not an
            // address the account currently holds.
            if (method && method.type === "email" && method.revokedAt === null) {
                existing = method.externalIdentifier;
            }
        }
        if (existing) {
            contentEl.innerHTML = shell(hubEl, verifiedHtml(hubEl, existing));
            window.flixCompileHoverStyles(contentEl);
            return;
        }
        contentEl.innerHTML = shell(hubEl, entryHtml(hubEl));
        window.flixCompileHoverStyles(contentEl);
        var form = contentEl.querySelector("[data-flix-email-form]");
        if (form) {
            form.addEventListener("submit", function (event) {
                event.preventDefault();
                void sendCode(hubEl, contentEl, form);
            });
        }
    }
    async function sendCode(hubEl, contentEl, form) {
        clearError(contentEl);
        var input = form.querySelector('input[name="email"]');
        var button = form.querySelector("[data-flix-email-send]");
        var email = (input && input.value.trim()) || "";
        if (!email) {
            showError(contentEl, t(hubEl, "i18nEmailInvalid", "Check the email format."));
            return;
        }
        busy(button, true);
        try {
            var started = await window.FlixAuthClient.startLinkEmail(email);
            contentEl.innerHTML = shell(hubEl, codeHtml(hubEl, email.toLowerCase()));
            window.flixCompileHoverStyles(contentEl);
            var codeForm = contentEl.querySelector("[data-flix-email-code-form]");
            if (codeForm) {
                codeForm.addEventListener("submit", function (event) {
                    event.preventDefault();
                    void confirmCode(hubEl, contentEl, codeForm, started.challengeId);
                });
            }
        }
        catch (err) {
            busy(button, false);
            showError(contentEl, messageFor(hubEl, err));
        }
    }
    async function confirmCode(hubEl, contentEl, form, challengeId) {
        clearError(contentEl);
        var input = form.querySelector('input[name="code"]');
        var button = form.querySelector("[data-flix-email-confirm]");
        var code = (input && input.value.trim()) || "";
        if (!code)
            return;
        busy(button, true);
        try {
            var result = await window.FlixAuthClient.verifyLinkEmail(challengeId, code);
            contentEl.innerHTML = shell(hubEl, verifiedHtml(hubEl, result.email));
            window.flixCompileHoverStyles(contentEl);
            var feedback = contentEl.querySelector("[data-flix-email-feedback]");
            if (feedback) {
                feedback.innerHTML = window.FlixHubRender.successState({
                    title: t(hubEl, "i18nEmailAdded", "Email verified."),
                    message: result.email,
                });
            }
        }
        catch (err) {
            busy(button, false);
            showError(contentEl, messageFor(hubEl, err));
        }
    }
    /**
     * One sentence per failure the reader can act on, and a single generic
     * line for everything else — so a code added on the server later cannot
     * start surfacing its internals here. A collision says only that the
     * address is in use; naming the other account is exactly the disclosure
     * the server refuses to make.
     */
    function messageFor(hubEl, err) {
        var code = typeof err === "object" && err !== null && "code" in err
            ? String(err.code)
            : "";
        if (code === "IDENTITY.INVALID_EMAIL_ADDRESS") {
            return t(hubEl, "i18nEmailInvalid", "Check the email format.");
        }
        if (code === "AUTHENTICATION.TOO_MANY_OTP_REQUESTS") {
            return t(hubEl, "i18nEmailTooMany", "Too many attempts. Wait a moment and try again.");
        }
        if (code === "AUTHENTICATION.EMAIL_ALREADY_LINKED_ELSEWHERE") {
            return t(hubEl, "i18nEmailInUse", "That email is already linked to an account.");
        }
        if (code === "OTP.CHALLENGE_EXPIRED") {
            return t(hubEl, "i18nEmailCodeExpired", "That code expired. Ask for a new one.");
        }
        if (code.indexOf("OTP.") === 0) {
            return t(hubEl, "i18nEmailCodeWrong", "That code is not right. Check it and try again.");
        }
        return t(hubEl, "i18nEmailFailed", "That did not work. Try again.");
    }
    window.FlixHubEmail = { render: render };
})();
